import { PermissionEnum } from '@Application/Security/Roles';
import { openSubjectToArchive } from '@UI/Pages/Subjects/Signals/subjectToArchiveSignal';
import WithPermission from '@UI/Providers/PermissionProvider/WithPermission';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';

type Props = {
	readonly subjectId: number;
	readonly isArchived: boolean;
};

/** Closing action of a dossier: archives it, or restores it when it is archived. A leaf action component. */
const SubjectDangerZone: React.FC<Props> = ({ subjectId, isArchived }) => {
	const handleArchiveClick = React.useCallback(() => {
		openSubjectToArchive(subjectId, isArchived);
	}, [subjectId, isArchived]);

	return (
		<WithPermission permission={PermissionEnum.SUBJECT_REMOVE}>
			<Button
				type="button"
				text
				label={isArchived ? 'Désarchiver le dossier' : 'Archiver le dossier'}
				onClick={handleArchiveClick}
			/>
		</WithPermission>
	);
};

export default SubjectDangerZone;
